import React from "react";
import { ResponsiveImage, ResponsiveSource, Link } from "@quintype/components";
import get from "lodash/get";
import { SectionName } from "../../atoms/section-name";
import PropTypes from "prop-types";
import "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";

function StoryHeader({ story = {}, color = "#ffffff", config = {} }) {
  const section = get(story, ["sections", "0"], {});
  return (
    <div styleName="blank-story-header">
      <DfpAd adtype="SponsoredLogo" />
      <figure styleName="header-image" className="header-image">
        <picture>
          {/* TODO: use Webp */}
          <ResponsiveSource
            media="(min-width: 768px)"
            slug={story["hero-image-s3-key"]}
            metadata={story["hero-image-metadata"]}
            aspectRatio={[1200, 630]}
            widths={[360, 940, 1200]}
            sizes="(max-width: 500px) 95vw, (max-width: 768px) 95vw, 90vw"
            imgParams={{ auto: ["format", "compress"] }}
          />

          <ResponsiveImage
            slug={story["hero-image-s3-key"]}
            metadata={story["hero-image-metadata"]}
            alt={story["headline"]}
            aspectRatio={[1200, 630]}
            defaultWidth={940}
            widths={[360, 940, 1200]}
            sizes="(max-width: 500px) 98vw, (max-width: 768px) 90vw, 90vw"
            imgParams={{ auto: ["format", "compress"] }}
          />
        </picture>
      </figure>
      <div styleName="header-content" className="header-content">
        {section && (
          <Link href={"/" + section.slug}>
            <SectionName name={section.name} isDark isExtraSmall />
          </Link>
        )}
      </div>
    </div>
  );
}

StoryHeader.propTypes = {
  story: PropTypes.object,
  color: PropTypes.bool,
  config: PropTypes.object
};

export { StoryHeader };
